import { TFunction } from 'i18next';
import { ReactText } from 'react';

export const FF_DUPLICATE_ERROR = 'customAnalysisDuplicatedNameExists';
export const KFA_DUPLICATE_ERROR = 'kfaDuplicatedNameExists';
export const GROUP_DUPLICATE_ERROR = 'analysiGroupDuplicatedNameExists';
export const TOPIC_DUPLICATE_ERROR = 'poTopicDuplicatedNameExists';
export const SA_DUPLICATE_ERROR = 'templateAnalysisDuplicatedNameExists';
export const TITLE_DUPLICATION_CONTROL_FAILED = 'titleDuplicityControlFailed';

/*
Good to know: 
FF/SA - contentType: 100 && (contentSubType: 400 (SA), contentSubType: 100 (FF))
KFA - contentType: 200
Topic - contentType: 400
group - contentType: 900
*/

export type MatchingItemType = {
  contentId: number;
  contentSubType: number;
  contentThreadId: number;
  contentType: number;
  title: string;
  versionStatus: number;
};

export type MatchItemsType = Array<MatchingItemType>;

export const getErrorMessageDuplicateTitle = (
  matchingItem: MatchingItemType,
  t: TFunction
): string => {
  switch (matchingItem?.contentType) {
    case 900:
      return t(GROUP_DUPLICATE_ERROR);
    case 400:
      return t(TOPIC_DUPLICATE_ERROR);
    case 200:
      return t(KFA_DUPLICATE_ERROR);
    case 100: {
      if (matchingItem.contentSubType === 100) {
        return t(FF_DUPLICATE_ERROR);
      }
      return t(SA_DUPLICATE_ERROR);
    }
    case 600:
      return t(SA_DUPLICATE_ERROR);
    default:
      return '';
  }
};

// used in SA
export const getErrorMessageWithLink = (
  matchingItem: MatchingItemType,
  projectId: ReactText
) => {
  switch (matchingItem?.contentType) {
    case 900:
      return {
        type: 'group',
        linkTo: `/projects/${projectId}/analyses-groups/custom`,
      };
    case 400:
      return {
        type: 'PO Topic',
        linkTo: `/projects/${projectId}`,
      };
    case 200:
      return {
        type: 'Key Focus Area',
        linkTo: `/projects/${projectId}/key-focus-areas/${matchingItem.contentId}/view`,
      };
    case 100:
      return {
        type: 'custom analysis',
        linkTo: `/projects/${projectId}/analyses/${matchingItem.contentId}/view`,
      };
    default:
      return {};
  }
};
